import { render, staticRenderFns } from "./NegotiationEditForm.vue?vue&type=template&id=583b1b7d"
import script from "./NegotiationEditForm.vue?vue&type=script&lang=js"
export * from "./NegotiationEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports